const validate = (values) => {
    const errors = {};
    // if (!values.domains) {
    //     errors.domains = "Please select a domain";
    // }
    if (!values.scpIssuers) {
        errors.roles = "Please select an scpIssuers";
    }
    if (!values.bankCode) {
        errors.bankCode = "Please enter a bank code";
    }
    if (!values.reportPrefix) {
        errors.reportPrefix = "Please enter a report issuer";
    }
    if (values.reportPrefix && values.reportPrefix.length > 20) {
        errors.reportPrefix = "Report issuer must be no longer than 20 characters";
    }
    if (!values.issuerNr && values.issuerNr !== 0) {
        errors.issuerNr = "Please enter an Issuer number";
    } else if (values && !/^[0-9]*$/.test(values.issuerNr)) {
        errors.issuerNr = "Please enter a valid issuer number";
    }

    return errors;
};

export default validate;
